import React from "react";
import List from "./ListAsync";
import Operation from "./OperationAsync";
import Search from "./SearchAsync";
import Loadable from "../../react-loadable";

const Transfer = Loadable({
  loader: () => import("./Transfer"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
Transfer.List = List;
Transfer.Operation = Operation;
Transfer.Search = Search;
export default Transfer;



// WEBPACK FOOTER //
// ./_antd1.11.2/transfer/index.jsx